import React from 'react';
import classNames from 'classnames';
import styles from './IconButton.scss';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface IconButtonProps {
  /**
   * Button Id
   */
  id?: string;
  /**
   * Button contents
   */
  label: string;
  /**
   * Click handler
   */
  onClick?: () => void;
  /**
   * Disabled element
   */
  disabled?: boolean;
  /**
   * Button type
   */
  mode: IconDefinition;
  /**
   * Additional class names
   */
  className?: string;
}

/**
 * Primary UI component for user interaction
 */
export const IconButton = (props: IconButtonProps) => {
  return (
    <button
      id={props.id ? props.id : undefined}
      className={classNames(styles['au-icon-btn'], props.className)}
      onClick={props.onClick}
      disabled={props.disabled}
      title={props.label}>
      <FontAwesomeIcon icon={props.mode} />
    </button>
  );
};
